import { Box, Grid } from '@mui/material'
import React from 'react'
import StickyTable from './StickyTable'

const ParametersTable = (props: AllProps): JSX.Element => {
  return (
    <Grid container item xs={12} >
        {props.title !== '' && (
          <Grid item xs={12} style={{ marginTop: '25px', fontFamily: 'Honeywell Sans Web', fontSize: '20px' }}>
            <p><u>{props.title}</u></p>
          </Grid>
        )}
        <Grid container item xs={12} >
            <Box
                sx={{
                  display: 'block',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  backgroundColor: '#3B3B3B',
                  padding: 1,
                  borderRadius: 1,
                  color: '#f0f0f0',
                  marginTop: props.title === '' ? '15px' : '10px',
                  width: '100%',
                  border: '1px solid #000000'
                }}
            >
            <StickyTable columns={props.columns} rows={props.rows} className={props.className} testId={props.testid} freezColumns= {props.freezColumns} />
            </Box>
        </Grid>
        </Grid>
  )
}

interface IParametersTable {
  title: string | null
  columns: any[]
  rows: any[]
  className?: string
  testid?: string
  freezColumns?: number
}
type AllProps = IParametersTable
export const MemorizedParametersTable = React.memo(ParametersTable)
